<template>
    <vue-modal :open="open">
        <div class="bax-modal-content bax-modal-icon-content text-center">
            <div class="bax-icon bax-remove d-flex align-items-center justify-content-center">
                <i class="icon-delete"></i>
            </div>
            <h2>Delete draft registration</h2>
            <p>Deleting this draft registration for {{deleteRequestItem.name}} will discard all their details.  Are you sure you want to delete this draft?</p>
            <div class="bax-modal-action-items">
                <button type="button" class="bax-btn bax-btn-bordered-blue-brand" @click.prevent="closeModal">No, go back</button>
                <button type="button" class="bax-btn bax-btn-blue-brand" :class="{ 'loading': submitting }" @click.prevent="onDelete()">Yes, delete</button>
            </div>
            <div class="feedback" v-if="error">
                {{error}}
            </div>
        </div>
    </vue-modal>
</template>
<script>

import PatientRegistationService from '@/core/api/tpn/patientRegistation.service';

export default {
    name: 'DeleteRegistationModal',
    props: {
        open: {
            required: true,
        },
        deleteRequestItem: {
            required: true,
        },
    },
    data() {
        return {
            submitting: false,
            error: false,
        };
    },
    methods: {
        closeModal() {
            if (!this.submitting) {
                this.$emit('modal_delete_close');
            }
        },
        onDelete() {
            if (!this.submitting) {
                this.submitting = true;
                this.error = false;
                PatientRegistationService.deletePatientRegistation(this.deleteRequestItem.id)
                .then((res) => {
                    this.submitting = false;
                    if (!res.data.deleted) {
                        this.error = 'Sorry, something went wrong';
                    } else {
                        this.$emit('modal_delete_close', this.deleteRequestItem.id);
                    }
                });
            }
        },
    },
};
</script>
